<h2 mat-dialog-title>No se pudo imprimir el rótulo</h2>

<mat-dialog-content class="mat-typography label-print-failure">
  <p class="label-print-failure__message">{{ data.message }}</p>

  @if (previewError$ | async; as previewError) {
  <p class="label-print-failure__error">{{ previewError }}</p>
  } @if (isLoading$ | async) {
  <div class="label-print-failure__loader">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  } @if (preview$ | async; as preview) {
  <div class="label-print-failure__preview">
    <img
      class="label-print-failure__image"
      alt="Vista previa del rótulo"
      [src]="preview"
    />
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="handleClose()">Cerrar</button>
  @if ((preview$ | async) === null) {
  <button
    mat-flat-button
    color="primary"
    [disabled]="(isLoading$ | async) === true"
    (click)="handleShowPreview()"
  >
    <mat-icon>visibility</mat-icon>
    Ver vista previa
  </button>
  }
</mat-dialog-actions>
